import { styled } from "@mui/material/styles";

export const Styles = styled("div")(({ theme }) => ({
  root: {
    backgroundColor: "#f8fafc",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
}));
